import { Alert, Snackbar } from "@mui/material";
import { FC } from "react";
import { useAppSelector } from "../../redux";
import { useNotification } from "./useNotification";

const FeedbackNotification: FC = () => {
	const feedbackNotificationState = useAppSelector((state) => state.feedbackNotification);

	const { closeNotification } = useNotification();

	return (
		<Snackbar
			open={feedbackNotificationState.show}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			autoHideDuration={3000}
			onClose={closeNotification}
		>
			<Alert
				onClose={closeNotification}
				variant="filled"
				severity={feedbackNotificationState.severity}
				sx={{ width: "100%" }}
				classes={{ filledError: "notification-error", filledWarning: "notification-warning" }}
			>
				{feedbackNotificationState.message}
			</Alert>
		</Snackbar>
	);
};

export default FeedbackNotification;
